<div>
  <div class="header-bar">
    <span>{{ title() }}</span>


    @if (expanded()) {
      <vulcan-icon (click)="toggleExpansion()" size="24px" icon="caret-up" weight="regular"></vulcan-icon>
    } @else {
      <vulcan-icon (click)="toggleExpansion()" size="24px" icon="caret-down" weight="regular"></vulcan-icon>
    }

  </div>

  <div class="rendered-content hide" [class.show]="expanded()">
    <ng-content></ng-content>
  </div>
</div>
